export enum EMenuAdmin {
  CLIENTES = "Clientes",
  USUARIOS = "Usuários",
  VAN_CONFIG = "VanConfig",
  LEAD = "Lead",
  INTEGRACOES = "Integrações",
  REGRAS_CO = "Regras de CO",
  NOTIFICACOES = "Notificações"
}
